(function(){
  'use strict';

  angular.module('eclipseApp.checkout').filter('formatTimeSlotRowLabel', function(){
    return function(input){
      switch (input) {
        // 2hr interval
        case '10A':
          return 'global.label.techInstallTimeSlot10AM';
          break;
        case '12P':
          return 'global.label.techInstallTimeSlot12PM';
          break;
        case '2P':
          return 'global.label.techInstallTimeSlot2PM';
          break;
        case '4P':
          return 'global.label.techInstallTimeSlot4PM';
          break;
        case '6P':
          return 'global.label.techInstallTimeSlot6PM';
          break;
        case '8A':
          return 'global.label.techInstallTimeSlot8AM';
          break;

        // 3hr interval
        case 'MOR':
          return 'global.label.techInstallTimeSlotEarlyMorning';
          break;
        case 'MID':
          return 'global.label.techInstallTimeSlotMidday';
          break;
        case 'AFT':
          return 'global.label.techInstallTimeSlotMidLateAfternoon';
          break;
        case 'NGT':
          return 'global.label.techInstallTimeSlotNight';
          break;
        case 'LAT':
          return 'global.label.techInstallTimeSlotLateNight';
          break;

        case 'AM':
          return 'global.label.techInstallTimeSlotAllMorning';
          break;
        case 'PM':
          return 'global.label.techInstallTimeSlotAllAfternoon';
          break;

        case 'ANY':
          return 'global.label.techInstallTimeSlotAnyTime';
          break;
        case 'DAY':
          return 'global.label.techInstallTimeSlotAllDay';
          break;

        default:
          return input;
      };
    };
  });
})();